import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

const uploadDocument = createAxiosThunk(
  'channelAdd/uploadDocument',
  ({ file }) => api.channel.uploadDocumentFile(file)
)

uploadDocument.reducers = builder => {
  builder.addCase(
    uploadDocument.fulfilled,
    (state, { payload, meta: { arg } }) => {
      const {
        property: { filename },
        url: { path },
      } = payload
      state.reviewDocuments
        .find(document => document.id === arg.id)
        .files.push({
          filename,
          path,
        })
    }
  )
}

export default uploadDocument
